import { createApi } from '@shared/redux/createApi';
import { serialize } from '../../../shared/lib/serialize';
import { format } from '../../../shared/lib/format';

const BASE_URL = '/liquidity/unstoppable-usdt';

const tags = {
  getUnstoppableLiquidity: 'getUnstoppableLiquidity',
  getUnstoppableIncoming: 'getUnstoppableIncoming',
  getUnstoppableOutgoing: 'getUnstoppableOutgoing',
};

const formatDate = (date) =>
  `${date.getDate()}/${format.addZeroBefore(date.getMonth() + 1)}/${date.getFullYear()}`;

const buildListParams = ({ page, limit, start, end }) => {
  let params = {
    page_number: page,
    page_size: limit,
  };

  if (start) {
    params.start = formatDate(start);
  }

  if (end) {
    params.end = formatDate(end);
  }

  return params;
};

export const unstoppableLiquidityApi = createApi({
  reducerPath: 'unstoppableLiquidityApi',
  tagTypes: [
    tags.getUnstoppableLiquidity,
    tags.getUnstoppableIncoming,
    tags.getUnstoppableOutgoing,
  ],

  endpoints: (builder) => ({
    getUnstoppableLiquidity: builder.query({
      query: () => ({
        method: 'get',
        url: BASE_URL,
      }),
      providesTags: [tags.getUnstoppableLiquidity],
    }),
    getUnstoppableIncoming: builder.query({
      query: ({ page, limit, start, end }) => ({
        method: 'get',
        url: `${BASE_URL}/incoming?${serialize(buildListParams({ page, limit, start, end }))}`,
      }),
      providesTags: [tags.getUnstoppableIncoming],
      transformResponse: (data) => {
        return {
          list: data.list,
          count: data.page_amount,
        };
      },
    }),
    getUnstoppableOutgoing: builder.query({
      query: ({ page, limit, start, end }) => ({
        method: 'get',
        url: `${BASE_URL}/outgoing?${serialize(buildListParams({ page, limit, start, end }))}`,
      }),
      providesTags: [tags.getUnstoppableOutgoing],
      transformResponse: (data) => {
        return {
          list: data.list,
          count: data.page_amount,
        };
      },
    }),
    depositUnstoppableLiquidity: builder.mutation({
      query: (data) => ({
        method: 'post',
        url: `${BASE_URL}/add`,
        body: data,
      }),
      invalidatesTags: [
        tags.getUnstoppableLiquidity,
        tags.getUnstoppableIncoming,
        tags.getUnstoppableOutgoing,
      ],
    }),
    withdrawUnstoppableLiquidity: builder.mutation({
      query: (data) => ({
        method: 'post',
        url: `${BASE_URL}/subtract`,
        body: data,
      }),
      invalidatesTags: [
        tags.getUnstoppableLiquidity,
        tags.getUnstoppableIncoming,
        tags.getUnstoppableOutgoing,
      ],
    }),
  }),
});

export const {
  useGetUnstoppableLiquidityQuery,
  useGetUnstoppableIncomingQuery,
  useGetUnstoppableOutgoingQuery,
  useDepositUnstoppableLiquidityMutation,
  useWithdrawUnstoppableLiquidityMutation,
} = unstoppableLiquidityApi;
